// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1TdJR","comment":"styles_comment__1k_ut"};